import { api } from './client';
import type { Branding } from '../branding';

export const siteApi = {
  /** Herkese açık marka ayarları (login ekranı dahil). */
  get: () => api.get<{ site: Partial<Branding> }>('/site').then((r) => r.site),
};
